
@if (printViewData) {
  <div>
    <h1>{{printViewData.pageTitle | hisUi}}</h1>
    <button
      iconPos="left"
      (click)="backToSearchResult()" >
      <span>{{'common.backToSearchResult'|hisUi}}</span>
    </button>
    <button
      iconPos="left"
      (click)="printPage()" >
      <span>{{'common.print'|hisUi}}</span>
    </button>
    @if (printViewData.showSearchInfo) {
      <div>
        <his-search-result-search-info
          [queryParams]="printViewData.queryParams"
          [searchConfigFile]="printViewData.searchConfigFile">
        </his-search-result-search-info>
        <div class="clearerSpaceAboveHalfEm"></div>
      </div>
    }
    <his-search-result #SearchResultComponent
      [showTitle]="true"
      [showNewSearchButton]="false"
      [showChangeSearchButton]="false"
      [showTableConfig]="false"
      [showSearchInfo]="false"
      [searchShowPrintviewButton]="false"
      [ignoreForBackToSearchResultNavigation]="true"
      [showPaginator]="false"
      [maxRows]= "printViewData.searchResultSize"
      [resultRowsPerPage]="printViewData.searchResultSize">
    </his-search-result>
  </div>
}
